import Full from 'Container/Full'

// component
const APIupload = () => import('Views/settings/SnsUpload')
const Settings = () => import('Views/settings/Settings')

// helpers
import { checkAuthorization, checkIp } from '../helpers/helpers.js'

export default {
  meta: { requiresAuth: true },
  beforeEnter(to, from, next) {
    checkAuthorization(next)
    checkIp(next)
    next()
  },
  path: '/apiupload',
  component: Full,
  meta: { requiresAuth: true },
  children: [
    {
      path: '',
      component: Settings,
      children: [
        {
          path: '',
          component: APIupload,
          meta: { title: '管理者設定' },
        },
      ],
    },
  ],
}
